import React from 'react';

import Dialog, {
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText
} from 'material-ui/Dialog';

import Button from 'material-ui/Button';

const buttonStyle = {
  width: '45px',
  fontSize: '13px',
  color: '#FFF',
  background: '#002053',
  borderRadius: '3px',
  textTransform: 'capitalize',
};

class RenderDialog extends React.Component {
  handleClose = () => {
    this.props.onClose(this.props.selectedValue);
  };

  handleAgree = () => {
    this.props.onAgree();
  };

  render() {
    const { title, message, showActions, confirmButton, ...other } = this.props;
    let widthVal;
    switch (message) {
      case 'Experian ID or AutoTec ID already exists for another location. Please check the ID(s).':
        widthVal = '500px';
        break;
      case 'Your account has been successfully verified. Please re-enter your username and password to log into the system.':
        widthVal = '500px';
        break;
      case 'Error: Network Error':
        return 0;
      default:
        widthVal = '300px';
    }

    return (
      <Dialog
        onClose={this.handleClose}
        disableEnforceFocus
        className="alert_dialog"
        aria-labelledby="simple-dialog-title"
        PaperProps={{
          style: {
            display: 'flex',
            alignItems: 'center',
            borderRadius: 7,
            boxShadow:
              '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)'
          }
        }}
        {...other}
      >
        {title && <DialogTitle id="simple-dialog-title">{title}</DialogTitle>}
        <DialogContent>
          <DialogContentText style={{ width: widthVal, textAlign: "center" }}>
            {message}
          </DialogContentText>
        </DialogContent>
        {confirmButton && (
          <DialogActions style={{ paddingBottom: '20px' }}>
            <Button
              style={buttonStyle}
              onClick={this.handleClose}
            >
              Ok
            </Button>
          </DialogActions>
        )}
        {showActions && (
          <DialogActions>
            <Button
              style={buttonStyle}
              onClick={this.handleAgree}
            >
              Yes
            </Button>
            <Button
              style={buttonStyle}
              onClick={this.handleClose}
            >
              No
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default RenderDialog;



// WEBPACK FOOTER //
// ./src/helpers/RenderDialog.js